export interface AddressValues {
  street: string | undefined
  houseNumber: string | undefined
}

export const HOUSENUMBER_REGEX =
  /(\d+\s?[a-z]{0,3}\s?(-\s?\d*\s?[a-z]{0,3}){0,1})$/i

function removeTrailingComma(street: string) {
  return street.replace(/,\s*$/, '')
}

interface HouseNumberMatch {
  isExact: boolean
  houseNumber: string
}

function getHousenumber(street: string): HouseNumberMatch {
  const match = street.match(HOUSENUMBER_REGEX)

  if (!match) {
    return {
      isExact: false,
      houseNumber: '',
    }
  }

  const houseNumber = match[0]

  return {
    isExact: match.input?.length === houseNumber.length,
    houseNumber,
  }
}

export function getStreetAndHouseNumber(
  value: string | undefined,
): AddressValues {
  const stringValue = value ? `${value}` : undefined
  if (!stringValue) {
    return {
      street: undefined,
      houseNumber: undefined,
    }
  }

  const { houseNumber, isExact } = getHousenumber(stringValue)

  if (houseNumber.length === 0) {
    return {
      houseNumber: undefined,
      street: removeTrailingComma(stringValue),
    }
  }

  if (isExact) {
    return {
      street: undefined,
      houseNumber,
    }
  }

  const street = removeTrailingComma(
    stringValue.substring(0, stringValue.lastIndexOf(houseNumber)).trim(),
  )

  if (street.length === 0) {
    return {
      street: removeTrailingComma(stringValue),
      houseNumber: undefined,
    }
  }

  return {
    street,
    houseNumber,
  }
}
